import styled from 'styled-components';
import { black, darkgrey, dividerColor, grey, white } from 'styles/Colors';

export const TaggingInfo = styled.div`
  margin-top: 4px;
  font-size: 13px;
  line-height: 1.15;
  letter-spacing: 0.5px;
  color: ${grey};
`;

export const Teams = styled.div`
  font-family: Oswald;
  font-weight: 500;
  text-transform: uppercase;
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.5px;
`;

export const Versus = styled.span`
  font-size: 24px;
  line-height: 1;
  letter-spacing: 0.55px;
`;

export const Controls = styled.div`
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.58px;
  color: ${darkgrey};
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const Save = styled.div`
  margin-right: 24px;
  cursor: pointer;
  &.disabled {
    cursor: default;
    opacity: 0.7;
  }
`;

export const SaveAndCompleteLater = styled.div`
  margin-right: 29px;
  cursor: pointer;
  svg {
    display: inline;
  }
  &.disabled {
    cursor: default;
    opacity: 0.7;
  }
`;

export const TopBarWrapper = styled.div`
  width: 100%;
  height: 95px;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.08);
  background: ${white};
  padding: 16.3px 21px 17.3px 31px;
  font-family: Lato;
  color: ${black};
  display: flex;
  justify-content: space-between;
  z-index: 1;
  position: relative;
`;

export const LeftSide = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const Divider = styled.div`
  width: 1px;
  height: 24px;
  background-color: ${dividerColor};
`;
